module.exports = __webpack_public_path__ + "static/media/pokemon_logo.493cd920.png";